import axios from 'axios'
import store from '@/store'
import { chatbotBaseUrl, LIVE_URL } from '@/modules/Chatbot/backend'

// Separate instance for the Python chatbot API. Keep it independent from
// http.js so chatbot authentication errors do not log the portal user out.
const httpChatbot = axios.create({
  baseURL: process.env.VUE_APP_CHATBOT_API_URL
})

// The chatbot API authenticates with the SAME portal login JWT (verified there
// with the shared giscreening secret). Send it as a Bearer token; its `id` claim
// identifies the user so their saved conversations stay private to them.
httpChatbot.interceptors.request.use(config => {
  // A/B switch: chat calls go to the chosen chatbot; the settings dashboard
  // (/admin/*) always talks to the live one.
  config.baseURL = String(config.url || '').startsWith('/admin') ? LIVE_URL : chatbotBaseUrl()
  const token = store.state.USER.user.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => Promise.reject(error))

export default httpChatbot
